export default __webpack_public_path__ + "static/polsat-c1071ed45ac641589ea5c34ff46f6749.svg";